// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import FinanceAccount from "./finance-account.js"
import PlanContactType from "./plan-contact-type.js"
import Product from "./product.js"

const modelClassData = {
  "attributes": {
    "billing_period": {
      "column": {
        "default": null,
        "name": "billing_period",
        "null": true,
        "type": "integer"
      },
      "name": "billing_period",
      "selected_by_default": null,
      "translated": false
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": true
    },
    "finance_account_id": {
      "column": {
        "default": null,
        "name": "finance_account_id",
        "null": true,
        "type": "uuid"
      },
      "name": "finance_account_id",
      "selected_by_default": null,
      "translated": false
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": true
    },
    "introduction_price_product_id": {
      "column": {
        "default": null,
        "name": "introduction_price_product_id",
        "null": true,
        "type": "uuid"
      },
      "name": "introduction_price_product_id",
      "selected_by_default": null,
      "translated": false
    },
    "invoice_text": {
      "column": {
        "default": null,
        "name": "invoice_text",
        "null": true,
        "type": "text"
      },
      "name": "invoice_text",
      "selected_by_default": null,
      "translated": false
    },
    "invoice_text_for_other_schools": {
      "column": {
        "default": null,
        "name": "invoice_text_for_other_schools",
        "null": true,
        "type": "text"
      },
      "name": "invoice_text_for_other_schools",
      "selected_by_default": null,
      "translated": false
    },
    "invoice_text_for_public_schools": {
      "column": {
        "default": null,
        "name": "invoice_text_for_public_schools",
        "null": true,
        "type": "text"
      },
      "name": "invoice_text_for_public_schools",
      "selected_by_default": null,
      "translated": false
    },
    "max_price_product_id": {
      "column": {
        "default": null,
        "name": "max_price_product_id",
        "null": true,
        "type": "uuid"
      },
      "name": "max_price_product_id",
      "selected_by_default": null,
      "translated": false
    },
    "member_price_product_id": {
      "column": {
        "default": null,
        "name": "member_price_product_id",
        "null": true,
        "type": "uuid"
      },
      "name": "member_price_product_id",
      "selected_by_default": null,
      "translated": false
    },
    "min_price_product_id": {
      "column": {
        "default": null,
        "name": "min_price_product_id",
        "null": true,
        "type": "uuid"
      },
      "name": "min_price_product_id",
      "selected_by_default": null,
      "translated": false
    },
    "non_member_price_product_id": {
      "column": {
        "default": null,
        "name": "non_member_price_product_id",
        "null": true,
        "type": "uuid"
      },
      "name": "non_member_price_product_id",
      "selected_by_default": null,
      "translated": false
    },
    "name": {
      "column": null,
      "name": "name",
      "selected_by_default": null,
      "translated": true
    },
    "period_months": {
      "column": {
        "default": null,
        "name": "period_months",
        "null": false,
        "type": "integer"
      },
      "name": "period_months",
      "selected_by_default": null,
      "translated": false
    },
    "plan_type": {
      "column": {
        "default": null,
        "name": "plan_type",
        "null": false,
        "type": "string"
      },
      "name": "plan_type",
      "selected_by_default": null,
      "translated": false
    },
    "price_per_unit_product_id": {
      "column": {
        "default": null,
        "name": "price_per_unit_product_id",
        "null": true,
        "type": "uuid"
      },
      "name": "price_per_unit_product_id",
      "selected_by_default": null,
      "translated": false
    },
    "state": {
      "column": {
        "default": "active",
        "name": "state",
        "null": false,
        "type": "string"
      },
      "name": "state",
      "selected_by_default": null,
      "translated": false
    },
    "translated_state": {
      "column": null,
      "name": "translated_state",
      "selected_by_default": null,
      "translated": false
    },
    "translated_plan_type": {
      "column": null,
      "name": "translated_plan_type",
      "selected_by_default": null,
      "translated": false
    }
  },
  "className": "Plan",
  "collectionKey": "plans",
  "collectionName": "plans",
  "i18nKey": "plan",
  "camelizedLower": "plan",
  "name": "Plan",
  "nameDasherized": "plan",
  "pluralName": "plans",
  "ransackable_associations": [
    {
      "className": "Plan::Translation",
      "collectionName": null,
      "foreignKey": "plan_id",
      "name": "current_translation",
      "macro": "has_one",
      "resource_name": null,
      "through": null
    },
    {
      "className": "FinanceAccount",
      "collectionName": "finance_accounts",
      "foreignKey": "finance_account_id",
      "name": "finance_account",
      "macro": "belongs_to",
      "resource_name": "FinanceAccount",
      "through": null
    },
    {
      "className": "Product",
      "collectionName": "products",
      "foreignKey": "introduction_price_product_id",
      "name": "introduction_price_product",
      "macro": "belongs_to",
      "resource_name": "Product",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Product",
      "collectionName": "products",
      "foreignKey": "max_price_product_id",
      "name": "max_price_product",
      "macro": "belongs_to",
      "resource_name": "Product",
      "through": null
    },
    {
      "className": "Product",
      "collectionName": "products",
      "foreignKey": "member_price_product_id",
      "name": "member_price_product",
      "macro": "belongs_to",
      "resource_name": "Product",
      "through": null
    },
    {
      "className": "Product",
      "collectionName": "products",
      "foreignKey": "min_price_product_id",
      "name": "min_price_product",
      "macro": "belongs_to",
      "resource_name": "Product",
      "through": null
    },
    {
      "className": "Product",
      "collectionName": "products",
      "foreignKey": "non_member_price_product_id",
      "name": "non_member_price_product",
      "macro": "belongs_to",
      "resource_name": "Product",
      "through": null
    },
    {
      "className": "PlanContactType",
      "collectionName": "plan_contact_types",
      "foreignKey": "plan_id",
      "name": "plan_contact_types",
      "macro": "has_many",
      "resource_name": "PlanContactType",
      "through": null
    },
    {
      "className": "Product",
      "collectionName": "products",
      "foreignKey": "price_per_unit_product_id",
      "name": "price_per_unit_product",
      "macro": "belongs_to",
      "resource_name": "Product",
      "through": null
    },
    {
      "className": "Subscription",
      "collectionName": "subscriptions",
      "foreignKey": "plan_id",
      "name": "subscriptions",
      "macro": "has_many",
      "resource_name": "Subscription",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "Plan::Translation",
      "collectionName": null,
      "foreignKey": "plan_id",
      "name": "translations",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "billing_period",
      "column": {
        "default": null,
        "name": "billing_period",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "finance_account_id",
      "column": {
        "default": null,
        "name": "finance_account_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "introduction_price_product_id",
      "column": {
        "default": null,
        "name": "introduction_price_product_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "invoice_text",
      "column": {
        "default": null,
        "name": "invoice_text",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "invoice_text_for_other_schools",
      "column": {
        "default": null,
        "name": "invoice_text_for_other_schools",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "invoice_text_for_public_schools",
      "column": {
        "default": null,
        "name": "invoice_text_for_public_schools",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "max_price_product_id",
      "column": {
        "default": null,
        "name": "max_price_product_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "member_price_product_id",
      "column": {
        "default": null,
        "name": "member_price_product_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "min_price_product_id",
      "column": {
        "default": null,
        "name": "min_price_product_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "non_member_price_product_id",
      "column": {
        "default": null,
        "name": "non_member_price_product_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "old_finance_account_id",
      "column": {
        "default": null,
        "name": "old_finance_account_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_introduction_price_product_id",
      "column": {
        "default": null,
        "name": "old_introduction_price_product_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_max_price_product_id",
      "column": {
        "default": null,
        "name": "old_max_price_product_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_member_price_product_id",
      "column": {
        "default": null,
        "name": "old_member_price_product_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_min_price_product_id",
      "column": {
        "default": null,
        "name": "old_min_price_product_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_non_member_price_product_id",
      "column": {
        "default": null,
        "name": "old_non_member_price_product_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_price_per_unit_product_id",
      "column": {
        "default": null,
        "name": "old_price_per_unit_product_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "period_months",
      "column": {
        "default": null,
        "name": "period_months",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "plan_type",
      "column": {
        "default": null,
        "name": "plan_type",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "price_per_unit_product_id",
      "column": {
        "default": null,
        "name": "price_per_unit_product_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "state",
      "column": {
        "default": "active",
        "name": "state",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "FinanceAccount",
      "collectionName": "finance_accounts",
      "foreignKey": "finance_account_id",
      "name": "finance_account",
      "macro": "belongs_to",
      "resource_name": "FinanceAccount",
      "through": null
    },
    {
      "className": "Product",
      "collectionName": "products",
      "foreignKey": "introduction_price_product_id",
      "name": "introduction_price_product",
      "macro": "belongs_to",
      "resource_name": "Product",
      "through": null
    },
    {
      "className": "Product",
      "collectionName": "products",
      "foreignKey": "max_price_product_id",
      "name": "max_price_product",
      "macro": "belongs_to",
      "resource_name": "Product",
      "through": null
    },
    {
      "className": "Product",
      "collectionName": "products",
      "foreignKey": "member_price_product_id",
      "name": "member_price_product",
      "macro": "belongs_to",
      "resource_name": "Product",
      "through": null
    },
    {
      "className": "Product",
      "collectionName": "products",
      "foreignKey": "min_price_product_id",
      "name": "min_price_product",
      "macro": "belongs_to",
      "resource_name": "Product",
      "through": null
    },
    {
      "className": "Product",
      "collectionName": "products",
      "foreignKey": "non_member_price_product_id",
      "name": "non_member_price_product",
      "macro": "belongs_to",
      "resource_name": "Product",
      "through": null
    },
    {
      "className": "PlanContactType",
      "collectionName": "plan_contact_types",
      "foreignKey": "plan_id",
      "name": "plan_contact_types",
      "macro": "has_many",
      "resource_name": "PlanContactType",
      "through": null
    },
    {
      "className": "Product",
      "collectionName": "products",
      "foreignKey": "price_per_unit_product_id",
      "name": "price_per_unit_product",
      "macro": "belongs_to",
      "resource_name": "Product",
      "through": null
    }
  ],
  "paramKey": "plan",
  "primaryKey": "id"
}

/** Frontend model for Plan. */
export default class Plan extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {number | null} */
  billingPeriod() {
    return this.readAttributeUnderscore("billing_period")
  }

  /** @returns {boolean} */
  hasBillingPeriod() {
    const value = this.billingPeriod()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  financeAccountId() {
    return this.readAttributeUnderscore("finance_account_id")
  }

  /** @returns {boolean} */
  hasFinanceAccountId() {
    const value = this.financeAccountId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  introductionPriceProductId() {
    return this.readAttributeUnderscore("introduction_price_product_id")
  }

  /** @returns {boolean} */
  hasIntroductionPriceProductId() {
    const value = this.introductionPriceProductId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  invoiceText() {
    return this.readAttributeUnderscore("invoice_text")
  }

  /** @returns {boolean} */
  hasInvoiceText() {
    const value = this.invoiceText()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  invoiceTextForOtherSchools() {
    return this.readAttributeUnderscore("invoice_text_for_other_schools")
  }

  /** @returns {boolean} */
  hasInvoiceTextForOtherSchools() {
    const value = this.invoiceTextForOtherSchools()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  invoiceTextForPublicSchools() {
    return this.readAttributeUnderscore("invoice_text_for_public_schools")
  }

  /** @returns {boolean} */
  hasInvoiceTextForPublicSchools() {
    const value = this.invoiceTextForPublicSchools()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  maxPriceProductId() {
    return this.readAttributeUnderscore("max_price_product_id")
  }

  /** @returns {boolean} */
  hasMaxPriceProductId() {
    const value = this.maxPriceProductId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  memberPriceProductId() {
    return this.readAttributeUnderscore("member_price_product_id")
  }

  /** @returns {boolean} */
  hasMemberPriceProductId() {
    const value = this.memberPriceProductId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  minPriceProductId() {
    return this.readAttributeUnderscore("min_price_product_id")
  }

  /** @returns {boolean} */
  hasMinPriceProductId() {
    const value = this.minPriceProductId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  nonMemberPriceProductId() {
    return this.readAttributeUnderscore("non_member_price_product_id")
  }

  /** @returns {boolean} */
  hasNonMemberPriceProductId() {
    const value = this.nonMemberPriceProductId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {number} */
  periodMonths() {
    return this.readAttributeUnderscore("period_months")
  }

  /** @returns {boolean} */
  hasPeriodMonths() {
    const value = this.periodMonths()

    return this._isPresent(value)
  }

  /** @returns {string} */
  planType() {
    return this.readAttributeUnderscore("plan_type")
  }

  /** @returns {boolean} */
  hasPlanType() {
    const value = this.planType()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  pricePerUnitProductId() {
    return this.readAttributeUnderscore("price_per_unit_product_id")
  }

  /** @returns {boolean} */
  hasPricePerUnitProductId() {
    const value = this.pricePerUnitProductId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  state() {
    return this.readAttributeUnderscore("state")
  }

  /** @returns {boolean} */
  hasState() {
    const value = this.state()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedState() {
    return this.readAttributeUnderscore("translated_state")
  }

  /** @returns {boolean} */
  hasTranslatedState() {
    const value = this.translatedState()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedPlanType() {
    return this.readAttributeUnderscore("translated_plan_type")
  }

  /** @returns {boolean} */
  hasTranslatedPlanType() {
    const value = this.translatedPlanType()

    return this._isPresent(value)
  }

  /** @returns {import("./finance-account.js").default | null} */
  financeAccount() {
    return this._readBelongsToReflection({modelClass: FinanceAccount, reflectionName: "finance_account"})
  }

  /** @returns {Promise<import("./finance-account.js").default | null>} */
  loadFinanceAccount() {
    if (!("financeAccountId" in this)) throw new Error("Foreign key method wasn't defined: financeAccountId")

    const id = this.financeAccountId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "finance_account",
        model: this,
        modelClass: FinanceAccount
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./finance-account.js").default | null>} */
  ensureFinanceAccountLoaded() {
    return this.ensureAssociationLoaded("finance_account")
  }

  /** @returns {import("./product.js").default | null} */
  introductionPriceProduct() {
    return this._readBelongsToReflection({modelClass: Product, reflectionName: "introduction_price_product"})
  }

  /** @returns {Promise<import("./product.js").default | null>} */
  loadIntroductionPriceProduct() {
    if (!("introductionPriceProductId" in this)) throw new Error("Foreign key method wasn't defined: introductionPriceProductId")

    const id = this.introductionPriceProductId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "introduction_price_product",
        model: this,
        modelClass: Product
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./product.js").default | null>} */
  ensureIntroductionPriceProductLoaded() {
    return this.ensureAssociationLoaded("introduction_price_product")
  }

  /** @returns {import("./product.js").default | null} */
  maxPriceProduct() {
    return this._readBelongsToReflection({modelClass: Product, reflectionName: "max_price_product"})
  }

  /** @returns {Promise<import("./product.js").default | null>} */
  loadMaxPriceProduct() {
    if (!("maxPriceProductId" in this)) throw new Error("Foreign key method wasn't defined: maxPriceProductId")

    const id = this.maxPriceProductId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "max_price_product",
        model: this,
        modelClass: Product
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./product.js").default | null>} */
  ensureMaxPriceProductLoaded() {
    return this.ensureAssociationLoaded("max_price_product")
  }

  /** @returns {import("./product.js").default | null} */
  memberPriceProduct() {
    return this._readBelongsToReflection({modelClass: Product, reflectionName: "member_price_product"})
  }

  /** @returns {Promise<import("./product.js").default | null>} */
  loadMemberPriceProduct() {
    if (!("memberPriceProductId" in this)) throw new Error("Foreign key method wasn't defined: memberPriceProductId")

    const id = this.memberPriceProductId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "member_price_product",
        model: this,
        modelClass: Product
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./product.js").default | null>} */
  ensureMemberPriceProductLoaded() {
    return this.ensureAssociationLoaded("member_price_product")
  }

  /** @returns {import("./product.js").default | null} */
  minPriceProduct() {
    return this._readBelongsToReflection({modelClass: Product, reflectionName: "min_price_product"})
  }

  /** @returns {Promise<import("./product.js").default | null>} */
  loadMinPriceProduct() {
    if (!("minPriceProductId" in this)) throw new Error("Foreign key method wasn't defined: minPriceProductId")

    const id = this.minPriceProductId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "min_price_product",
        model: this,
        modelClass: Product
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./product.js").default | null>} */
  ensureMinPriceProductLoaded() {
    return this.ensureAssociationLoaded("min_price_product")
  }

  /** @returns {import("./product.js").default | null} */
  nonMemberPriceProduct() {
    return this._readBelongsToReflection({modelClass: Product, reflectionName: "non_member_price_product"})
  }

  /** @returns {Promise<import("./product.js").default | null>} */
  loadNonMemberPriceProduct() {
    if (!("nonMemberPriceProductId" in this)) throw new Error("Foreign key method wasn't defined: nonMemberPriceProductId")

    const id = this.nonMemberPriceProductId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "non_member_price_product",
        model: this,
        modelClass: Product
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./product.js").default | null>} */
  ensureNonMemberPriceProductLoaded() {
    return this.ensureAssociationLoaded("non_member_price_product")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./plan-contact-type.js").default>} */
  planContactTypes() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["plan_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "plan_contact_types",
        model: this,
        modelClass: PlanContactType
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./plan-contact-type.js").default>>} */
  loadPlanContactTypes() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["plan_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "plan_contact_types",
        model: this,
        modelClass: PlanContactType
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./plan-contact-type.js").default>>} */
  ensurePlanContactTypesLoaded() {
    return this.ensureAssociationLoaded("plan_contact_types")
  }

  /** @returns {import("./product.js").default | null} */
  pricePerUnitProduct() {
    return this._readBelongsToReflection({modelClass: Product, reflectionName: "price_per_unit_product"})
  }

  /** @returns {Promise<import("./product.js").default | null>} */
  loadPricePerUnitProduct() {
    if (!("pricePerUnitProductId" in this)) throw new Error("Foreign key method wasn't defined: pricePerUnitProductId")

    const id = this.pricePerUnitProductId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "price_per_unit_product",
        model: this,
        modelClass: Product
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./product.js").default | null>} */
  ensurePricePerUnitProductLoaded() {
    return this.ensureAssociationLoaded("price_per_unit_product")
  }
}
